import axios from "axios";
import Consts from "./Consts";
//import Promise from "promise";
import Utils from "./Utils";

export default {
  // https://api.dimu.org/api/solr/select?q=*&fq=identifier.owner:STO&wt=json&api.key=TXfNazNFTZO0P%2B2lfu9eTg&rows=100
  // https://api.dimu.org/api/solr/select?q=*&fq=identifier.owner:STO&wt=json&api.key=TXfNazNFTZO0P%2B2lfu9eTg&rows=100&fq=-artifact.type:Folder&fq=artifact.hasPictures:true&start=0

  getAll: (success, error, rows, start) => {
    if (Consts.dev.isLocal) {
      success(require("../temp/listData.json"));
    }
    var url = `${Consts.api.baseUrl}api/solr/select?q=*&fq=identifier.owner:STO&fq=-artifact.type:Folder&fq=artifact.hasChildren:false&fq=artifact.hasPictures:true&wt=json&api.key=${Consts.api.key}&rows=${rows}&start=${start}&sort=${Consts.api.sort} ${Consts.api.sortDirection}&omitHeader=true`;
    axios
      .get(url)
      .then(function (response) {
        Utils.lists.removeTechnicFromTitle(response.data.response.docs);
        success(response.data.response);
      })
      .catch(function (ex) {
        error(ex);
      });
  },

  // https://api.dimu.org/api/solr/select?q=jean&fq=identifier.owner:STO&wt=json&api.key=TXfNazNFTZO0P%2B2lfu9eTg&rows=100&fq=-artifact.type:Folder&fq=artifact.hasPictures:true&fq=artifact.ingress.production.toYear:[1940 TO 1950]&start=0
  //}api/solr/}&fq=identifier.owner:STO&fq=-artifact.type:Folder&fq=artifact.hasPictures:true&fq=artifact.ingress.production.toYear:[${yearFrom} TO ${yearTo}]&wt=json&api.key=${

  getSearch: function (success, error, query, yearFrom, yearTo, rows, start) {
    let that = this;
    if (Consts.dev.isLocal) {
      success(require("../temp/listData.json"));
    }
    var url = `${Consts.api.baseUrl}api/solr/select?q=${encodeURIComponent(
      query
    )}&fq=identifier.owner:STO&fq=artifact.hasChildren:false&wt=json&api.key=${
      Consts.api.key
    }&rows=${rows}&start=${start}&omitHeader=true`;
    axios
      .get(url)
      .then(function (response) {
        let json = response.data.response.docs;
        let categoryIds = Utils.lists.getCategoryFolderIds(json);
        if (categoryIds.length > 2) {
          that.getCategoryContent(
            (catResponse) => {
              json = json.concat(catResponse.docs);
              json = Utils.lists.fixSearchResults(json, yearFrom, yearTo);

              catResponse.docs = Utils.lists.removeDuplicates(
                json,
                "artifact.uuid"
              );
              catResponse.numFound = catResponse.docs.length;
              success(catResponse);
            },
            error,
            categoryIds,
            Consts.api.numberOfElements,
            0
          );
        } else {
          json = Utils.lists.fixSearchResults(json, yearFrom, yearTo);
          response.data.response.docs = Utils.lists.removeDuplicates(
            json,
            "artifact.uuid"
          );
          response.data.response.numFound = response.data.response.docs.length;
          success(response.data.response);
        }
      })
      .catch(function (ex) {
        error(ex);
      });
  },

  // https://api.dimu.org/api/artifact?owner=STO&identifier=M-no0153-53&mapping=simple_json&api.key=demo
  // https://api.dimu.org/api/artifact?owner=STO&identifier=STO.K.02248&mapping=simple_json&api.key=demo
  // https://api.dimu.org/artifact/uuid/0EDBE210-A4E8-461F-A00C-B31D3EDC0FA4
  getSingle: (id, success, error) => {
    //var url = `${Consts.api.baseUrl}/artifact?owner=STO&identifier=${id}&mapping=simple_json&api.key=${Consts.api.key}`; // old
    var url = `${Consts.api.baseUrl}artifact/uuid/${id}`;
    axios
      .get(url)
      .then(function (response) {
        success(response.data);
      })
      .catch(function (ex) {
        error(ex);
      });
  },
  getCategories: (success, error) => {
    var url = `${Consts.api.baseUrl}api/solr/select?q=*&fq=identifier.owner:STO&fq=artifact.type:Folder&wt=json&api.key=${Consts.api.key}&rows=${Consts.api.numberOfElements}&omitHeader=true`;
    axios
      .get(url)
      .then(function (response) {
        success(response.data.response);
      })
      .catch(function (ex) {
        error(ex);
      });
  },
  getCategoryContent: (success, error, uuid, rows, start) => {
    var url = `${Consts.api.baseUrl}api/solr/select?q=*&fq=identifier.owner:STO&fq=artifact.hasPictures:true&fq=artifact.folderUids:${uuid}&rows=${rows}&start=${start}&sort=${Consts.api.sort} ${Consts.api.sortDirection}&wt=json&api.key=${Consts.api.key}&omitHeader=true`;
    axios
      .get(url)
      .then((response) => {

        response.data.response.numFoundOnServer = response.data.response.numFound;
        
        let filtered = Utils.lists.fixCategoryResults(
          response.data.response.docs
        );
        response.data.response.docs = filtered;
        response.data.response.numFound = filtered.length;    
        success(response.data.response);
      })
      .catch((ex) => {
        error(ex);
      });
  },
  // https://api.dimu.org/artifact/uuid/B09F8E14-5304-44A8-8AB0-685FAD78975F
  getCategoryInfo: (success, error, uuid) => {
    const url = `${Consts.api.baseUrl}artifact/uuid/${uuid}`;
    axios
      .get(url)
      .then((response) => {
        success(response.data);
      })
      .catch((ex) => {
        error(ex);
      });
  },
  getNklData: (name, success, error) => {
    var url = `${Consts.api.baseUrlNkl}${name}`;
    axios
      .get(url)
      .then((response) => {
        success(response.data[0]);
      })
      .catch((ex) => {
        error(ex);
      });
  },
  getSnlData: (name, success, error) => {
    var url = `${Consts.api.baseUrlSnl}${name}`;
    axios
      .get(url)
      .then((response) => {
        success(response.data[0]);
      })
      .catch((ex) => {
        error(ex);
      });
  },
};
